module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAWBAMAAAD6A0vjAAAAGFBMVEX/gS3/gS3/gS3/gS3/gS3/gS3/gS3/gS0Z4JLoAAAAB3RSTlO79B6/uvMfGYQZbwAAAB9JREFUCNdjUAlRYGAvN2AQLy9gKKcMg8wAm6UgkAAAiZQaYThFypwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_yellow.png
// module id = yjv+
// module chunks = 0